import { render } from "./UserCircle.vue?vue&type=template&id=ba9bc522&scoped=true"
import script from "./UserCircle.vue?vue&type=script&lang=js"
export * from "./UserCircle.vue?vue&type=script&lang=js"

import "./UserCircle.vue?vue&type=style&index=0&id=ba9bc522&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba9bc522"]])

export default __exports__